// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ueZd","notes":"Notes_notes__iar0I"};